import type { ColDef, ICellRendererParams } from 'ag-grid-community'
import type { ReactElement } from 'react'
import type { Menu } from '~/components/ActionMenu'

import ActionMenu from '~/components/ActionMenu'
import { copyText } from '~/utils/navigator'
import { actionsColDef, applicationColDef, platformColDef } from '~/utils/table'

const ActionsCellRenderer = ({ data }: ICellRendererParams<{ feature: string }>): ReactElement => {
  if (data) {
    const actions: Menu['actions'] = [
      {
        action: () => {
          copyText(data.feature, 'Feature copied to clipboard.')
        },
        label: 'Copy feature',
      },
    ]
    return <ActionMenu menu={{ actions }} placement="top" />
  }

  return <div />
}

const columns: ColDef[] = [
  applicationColDef({
    field: 'app',
    headerName: 'App',
    maxWidth: 80,
    sortable: false,
    suppressHeaderMenuButton: true,
  }),
  platformColDef({
    field: 'deviceType',
  }),
  {
    field: 'feature',
    headerName: 'Feature',
    suppressHeaderMenuButton: true,
  },
  actionsColDef(ActionsCellRenderer, {
    field: 'actions',
  }),
]

export default columns
